// extracted by mini-css-extract-plugin
module.exports = {"container":"FloatBullets_container__25V4J","bullet":"FloatBullets_bullet__3qAeI","activeBullet":"FloatBullets_activeBullet__3BmCI","bulletLink":"FloatBullets_bulletLink__1ODNY"};